module.exports = __webpack_public_path__ + "media/images/JEFA4-News-Vol-13-No-2-fall-winter-2020-a7e33bc8d1a62dab1936a6dbe78e2c2b.jpg";